import React, { useEffect, useState, useContext } from 'react';
import {
  Box,
  Typography,
  Collapse,
  IconButton,
  Paper,
} from '@mui/material';
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from '@mui/x-data-grid';
import {
  KeyboardArrowDown,
  KeyboardArrowUp,
} from '@mui/icons-material';
import { CashCrewContainer } from './CashCrewAnalysisElements';
import AnalysisAssetsTable from './AnalysisAssetsTable';
import { AccountContext } from '../Accounts';
import { useNavigate } from 'react-router-dom';
import GetReflectionTeams from './GetReflectionTeams';

function RenderAnalysisTable() {
  const [status, setStatus] = useState(false);
  const { getSession } = useContext(AccountContext);
  const [teams, setTeams] = useState([]);
  const [expandedRow, setExpandedRow] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    getSession()
      .then(() => setStatus(true))
      .catch(err => {
        console.error(err);
        navigate('/signin');
      });
  }, []);

  useEffect(() => {
    if (status) {
      GetReflectionTeams().then(data => {
        setTeams(data);
      });
    }
  }, [status]);

  const columns = [
    {
      field: 'expand',
      headerName: '',
      sortable: false,
      width: 50,
      renderCell: (params) => (
        <IconButton
          size="small"
          onClick={() =>
            setExpandedRow(expandedRow === params.id ? null : params.id)
          }
        >
          {expandedRow === params.id ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
        </IconButton>
      ),
    },
    { field: 'teamCaptain', headerName: 'Crews', flex: 1 },
    { field: 'totalCost', headerName: 'Cost', flex: 1 },
    { field: 'projectedScore', headerName: 'Total', flex: 1 },
  ];

  return status ? (
    <CashCrewContainer>
      <Typography variant="h6" sx={{ mb: 2, color: '#101522' }}>
        Optimal Teams
      </Typography>
      <Box sx={{ height: 600, width: '60%' }}>
        <DataGrid
          rows={teams}
          columns={columns}
          getRowId={(row) => row.teamCaptain}
          disableColumnMenu
          disableSelectionOnClick
          hideFooter
          sx={{
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#F5F5F5',
              color: '#101522',
              fontSize: '20px',
              fontWeight: 'bold',
            },
            '& .MuiDataGrid-row': {
              backgroundColor: '#101522',
              color: 'white',
              fontSize: '17px',
            },
          }}
        />
        {expandedRow !== null && (
          <Collapse in={true} timeout="auto" unmountOnExit>
            <Paper sx={{ mt: 2, p: 2 }}>
              <AnalysisAssetsTable
                assets={teams.find((t) => t.teamCaptain === expandedRow)?.assetList || []}
              />
            </Paper>
          </Collapse>
        )}
      </Box>
    </CashCrewContainer>
  ) : null;
}

export default RenderAnalysisTable;
